import { useState, useEffect, useCallback } from 'react';
import { BaseFormModal } from '@/components/BaseFormModal';

export interface AlertTypeItem {
  id: number;
  type: string;
  backgroundColor: string;
  borderColor: string;
  textColor: string;
}

export interface EditCallAlertTypesModalProps {
  open: boolean;
  alertTypes?: AlertTypeItem[];
  theme?: string;
  onSave: (data: { callAlertTypes: Array<{ callAlertTypeId: number; type: string }> }) => void;
  onCancel: () => void;
}

export function EditCallAlertTypesModal({
  open,
  alertTypes = [],
  theme,
  onSave,
  onCancel,
}: EditCallAlertTypesModalProps) {
  const [localAlertTypes, setLocalAlertTypes] = useState<AlertTypeItem[]>([]);

  // Deep copy and sort alert types when modal opens
  useEffect(() => {
    if (open) {
      const copy: AlertTypeItem[] = JSON.parse(JSON.stringify(alertTypes || []));
      copy.sort((a, b) => a.id - b.id);
      setLocalAlertTypes(copy);
    }
  }, [open, alertTypes]);

  const handleTypeChange = useCallback((index: number, value: string) => {
    setLocalAlertTypes((prev) => {
      const updated = prev.slice();
      updated[index] = { ...updated[index], type: value };
      return updated;
    });
  }, []);

  const handleSave = useCallback(() => {
    const typeList = localAlertTypes.map((elt) => ({
      callAlertTypeId: elt.id,
      type: elt.type,
    }));
    onSave({ callAlertTypes: typeList });
  }, [localAlertTypes, onSave]);

  return (
    <BaseFormModal
      open={open}
      title="Edit Call Alert Types"
      theme={theme}
      dialogClass="kstc-dialog--form"
      hint="Update the names of the Call Alert types. These are shown in the Call Alerts grid to make it easier to identify which Call Alerts correspond to which colors."
      saveText="Save Types"
      onSave={handleSave}
      onCancel={onCancel}
    >
      {localAlertTypes.map((alertType, index) => (
        <div key={alertType.id} className="kstc-form-group kstc-alert-type-row">
          <div
            className="kstc-alert-type-preview"
            style={{
              color: '#' + alertType.textColor,
              backgroundColor: '#' + alertType.backgroundColor,
              borderColor: '#' + alertType.borderColor,
            }}
          >
            Call Alert Content
          </div>
          <input
            type="text"
            className="kstc-input"
            value={alertType.type}
            onChange={(e) => handleTypeChange(index, e.target.value)}
            placeholder="Type name..."
          />
        </div>
      ))}
    </BaseFormModal>
  );
}

(window as any).EditCallAlertTypesModalReact = EditCallAlertTypesModal;
